export enum PaymentMethodType {
  POINTS = 'points',
  CREDIT_CARD = 'credit_card',
  VOUCHER = 'voucher',
  CREDIT_NOTE = 'credit_note',
  QANTAS_GROUP_CREDIT_VOUCHER = 'qantas_group_credit_voucher',
}
